<template>
  <ConfirmationModal
    :bodyText="bodyText"
    cancelText="cancel"
    continueText="delete"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    headerText="Delete Active Directory Domain"
    :mainActionAttention="true"
  />
</template>
<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import ActiveDirectoryApi from 'client/api/v2/ActiveDirectoryApi';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus, { ModalEvents } from 'client/components/Modal/ModalEventBus';

const {
  DirectoryNameConsts,
  DirectoryTypeConsts,
  DirectoryTypeKeys,
  ItemTypeConsts,
  StoreModelMap,
} = Constants;

const storeModel = StoreModelMap[ItemTypeConsts.activeDirectory];

export default {
  name: 'DeleteAdDomainModal',

  components: {
    ConfirmationModal,
  },

  props: {
    handleAfterDeleted: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      bodyText: 'Deleting an AD Domain will remove the AD Domain from JumpCloud, but will not remove any agents you may have installed on the Domain Controller.  Those will need to be uninstalled manually. Are you sure you want to continue?',
    };
  },

  computed: {
    ...mapState(storeModel, ['item']),
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),

    handleCancel() {
      ModalEventBus.close();
    },

    handleContinue() {
      const { activeDirectory } = DirectoryTypeKeys;
      const type = DirectoryTypeConsts[activeDirectory];
      const self = this;

      ActiveDirectoryApi
        .delete(this.item.id)
        .then(() => {
          ModalEventBus.$once(ModalEvents.transitionEnd, () => {
            self.handleAfterDeleted();
          });
          ModalEventBus.close();
        })
        .catch((error) => {
          this.triggerErrorNotification({
            title: `Unable to delete ${DirectoryNameConsts[type]}!`,
            message: error && error.message ? error.message : undefined,
          });
        });
    },
  },
};
</script>
